import { DsButtonBase } from "../DsButtonBase/DsButtonBase"
import { DsButtonsType } from "../DsButtonsTypes"

export type DsButtonSuccessProps = DsButtonsType

export function DsButtonSuccess(props: DsButtonSuccessProps) {
  return <DsButtonBase {...props} color="green" variant="filled" />
}
